import React, { useEffect, useState, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
	brandMention,
	createHOst,
	deleteIp,
	brandMentionAction,
	brandMentionAdd,
} from "../../actions/inventory";
import { fetchCustomerDomains } from "../../actions/customer";
import { Link, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "../Pagination/Pagination";
import moment from "moment";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import $ from "jquery";
import { toastr } from "react-redux-toastr";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import Fancybox from "../../utils/Fancybox";
import { takeDown, bulkTakeDown } from "../../actions/look-alike";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { API_URL } from "../../utils/constant";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Modal } from "react-bootstrap";
import { rescanSingle } from "../../actions/users";
import "../../assets/css/recommendation-modal.css";

function getModalStyle() {
	const top = 50;
	const left = 50;

	return {
		top: `${top}%`,
		left: `${left}%`,
		transform: `translate(-${top}%, -${left}%)`,
	};
}

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		overflowX: "auto",
	},
	table: {
		minWidth: 650,
	},
	paper: {
		position: "absolute",
		backgroundColor: theme.palette.background.paper,
		padding: theme.spacing(2, 4, 3),
		textAlign: "center",
		minWidth: "600px",
		minHeight: "300px",
	},
}));

const tableStyles = {
	table: {
		width: "100%",
		tableLayout: "fixed",
	},
	td: {
		padding: "8px",
		verticalAlign: "top",
		wordBreak: "break-word",
		maxWidth: "33%",
		whiteSpace: "pre-wrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
};

const AssetDiscovery = () => {
	const dispatch = useDispatch();
	const myRef = useRef(null);
	const [isModal, setModal] = useState(false);
	const [isModalTwo, setModalTwo] = useState("");
	const [totalItems, setTotalItems] = useState(0);
	const [modalHeading, setModalHeading] = useState("");
	const [modalBody, setModalBody] = useState([]);

	const [applyCountrySearch, setApplyCountrySearch] = useState([]);
	const [applyCloudSearch, setApplyCloudSearch] = useState([]);

	const [certModal, setCertModal] = useState(false);
	const [certModalBody, setCertModalBody] = useState();

	const [page, setPage] = useState(1);
	const [firstLoad, setFirstLoad] = useState(true);
	const [PageSize, setPerPage] = useState(10);
	const [search, setSearch] = useState("");
	const [filterData, setfilterData] = useState("all");
	const [addIpModel, setAddIpModel] = useState(false);
	const [modalStyle] = useState(getModalStyle);
	const [addHost, setHost] = useState("");
	const classes = useStyles();
	const [ipRemoveModal, setIpRemoveModal] = useState(false);
	const [ipId, setIpId] = useState("");
	const [limit, setLimit] = useState(10);
	const [isTakeDownModal, setTakeDownModal] = useState("");
	const [isBulkTakeDownModal, setBulkTakeDownModal] = useState(false);
	const [bulkTakeDownComment, setBulkTakeDownComment] = useState("");
	const [modalDetailsOne, setModalDetailsOne] = useState("");
	const [modalDetailsTwo, setModalDetailsTwo] = useState("");
	const [modalDetailsDataOne, setModalDetailsDataOne] = useState("");
	const [modalDetailsDataTwo, setModalDetailsDataTwo] = useState("");
	const [stolenLocation, setStolenLocation] = useState("");
	const [contenSource, setContenSource] = useState("");
	const [infringingIp, setInfringingIp] = useState("");
	const [editorContent, setEditorContent] = useState("");
	const [rowId, setRowId] = useState("");
	const [subject, setSubject] = useState("");
	const [category, setCategory] = useState("all");
	const [forValue, setForValue] = useState("forever");
	const [lookalikeAppId, setLookalikeAppId] = useState([]);
	const [actionNote, setActionNote] = useState("");
	const [action, setAction] = useState("");
	const [selectedValue, setSelectedValue] = useState("pleaseSelect");
	const queryParameters = new URLSearchParams(window.location.search);
	const latest = queryParameters.get("latest");
	const vendorName = sessionStorage.getItem("vendorName");
	const vendorId = sessionStorage.getItem("vendorId");
	const [userComment, setUserComment] = useState("");
	const [isAddBrandMentionModal, setAddBrandMentionModal] = useState(false);
	const [lookalike, setLookalike] = useState("");
	const [original, setOriginal] = useState("");
	const [fuzzer, setFuzzer] = useState("typo");
	const [showUrlWarningModal, setShowUrlWarningModal] = useState(false);
	const [redirectUrl, setRedirectUrl] = useState("");
	const [isTicketDetailsModal, setIsTicketDetailsModal] = useState(false);
	const [selectedTicket, setSelectedTicket] = useState(null);
	const [domain, setDomain] = useState("");
	const [uploadedFile, setUploadedFile] = useState(null);
	const [filePreview, setFilePreview] = useState(null);
	const fileInputRef = useRef(null);
	const [isRecommendationModal, setIsRecommendationModal] = useState(false);
	const [refreshKey, setRefreshKey] = useState(0);
	const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');

	// Handle file selection
	const handleFileChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			// Check file size (max 10MB)
			if (file.size > 10 * 1024 * 1024) {
				toastr.error("Error", "File size must be less than 10MB");
				e.target.value = null;
				return;
			}

			setUploadedFile(file);

			// Create preview for images
			if (file.type.startsWith("image/")) {
				const reader = new FileReader();
				reader.onloadend = () => {
					setFilePreview(reader.result);
				};
				reader.readAsDataURL(file);
			} else {
				setFilePreview(null);
			}
		}
	};

	const auth = useSelector((state) => state?.auth?.user);
	const userPermission = useSelector((state) => {
		return state?.auth?.user?.modulePermissionsConfig?.bs?.e;
	});

	const { orgId } = useParams();
	const id = useSelector((state) => {
		if (orgId) {
			return orgId;
		} else {
			return (
				state?.summary?.localClient?._id ||
				state?.summary?.clients?.[0]?._id
			);
		}
	});
	const client = useSelector(
		(state) => state?.summary?.localClient || state?.summary?.clients?.[0]
	);

	const customerDomains = useSelector(
		(state) => state?.customer?.customerDomains?.data || []
	);

	let domains = "";
	client?.domains?.forEach((row) => {
		domains += "," + row;
	});
	// latest
	let table = useSelector((state) => state?.inventory?.brand);
	let rating = useSelector(
		(state) => state?.inventory?.brand?.individualRating
	);
	const scanCompleted = useSelector((state) => state.inventory.scanCompleted);

	// Add useEffect to fetch customer domains
	useEffect(() => {
		// Fetch domains for the current client/organization
		if (id) {
			dispatch(fetchCustomerDomains(id));
		}
	}, [id, dispatch]);

	useEffect(() => {
		const delayedSearch = setTimeout(() => {
			brandMention(id, dispatch, page, category, search, limit, domain);
		}, 500);

		return () => clearTimeout(delayedSearch);
	}, [search, id, page, category, dispatch, limit, domain, refreshKey]);

	useEffect(() => {
		setTotalItems(table?.totalBrandMentions);
	}, [table?.totalBrandMentions]);

	const createHost = () => {
		let host = $("#hostName").val();
		if (!host) {
			toastr.error("Error", "Please enter host address.");
			return false;
		}
		createHOst({ organisationId: id, ip: host }, dispatch);
	};

	const modalBodyData = (
		<div style={modalStyle} className={classes.paper}>
			<div
				style={{
					display: "flex",
					justifyContent: "end",
				}}
			>
				<button
					type="button"
					data-dismiss="modal"
					aria-label="Close"
					onClick={() => setAddIpModel(false)}
				>
					<span aria-hidden="true">×</span>
				</button>
			</div>
			<div>
				<h2>Add Targets</h2>
				<div>
					<div className="row">
						<label className="col-form-label col-md-4">
							Host Name
						</label>
						<div className="col-md-7">
							<input
								type="text"
								className="form-control"
								// style={{ width: 200 }}
								id="hostName"
								placeholder="Add Host"
								value={addHost}
								onChange={(e) => setHost(e.target.value)}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-12">
							<div className="text-right mt-4">
								<button
									type="submit"
									className="btn btn-primary"
									onClick={() => createHost()}
								>
									Add Host
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);

	const handleEditorChange = (even, editor) => {
		const data = editor.getData();
		setEditorContent(data); // Update the state with the new content
	};

	const submitTakeDownValue = async () => {
		if (userComment == "") {
			toastr.error("Error", "Comment cannot be empty.");
			return false;
		}

		if (!rowId) {
			toastr.error("Error", "No record selected for takedown.");
			return false;
		}

		// Store rowId locally to prevent state issues
		const currentRowId = rowId;

		try {
			// Create FormData for file upload
			const formData = new FormData();
			formData.append("organisationId", id);
			formData.append("recordId", currentRowId);
			formData.append("userComment", userComment);
			formData.append("moduleName", "brand_mentions");

			// Add file if uploaded
			if (uploadedFile) {
				formData.append("file", uploadedFile);
			}

			// Close modal first
			setTakeDownModal(false);

			// Reset the form fields immediately
			setUserComment("");
			setUploadedFile(null);
			setFilePreview(null);
			setRowId("");
			// Clear file input
			if (fileInputRef.current) {
				fileInputRef.current.value = "";
			}

			// Call takeDown API with FormData
			await takeDown(formData, dispatch);

			// Directly call brandMention API to refresh the list
			setTimeout(() => {
				brandMention(id, dispatch, page, category, search, limit, domain);
			}, 500);
		} catch (error) {
			console.error("Error submitting takedown request:", error);
			// Reset on error
			setTakeDownModal(false);
			setUserComment("");
			setUploadedFile(null);
			setFilePreview(null);
			setRowId("");
			if (fileInputRef.current) {
				fileInputRef.current.value = "";
			}
		} finally {
			// Always refresh the list regardless of success or error
			setTimeout(() => {
				brandMention(id, dispatch, page, category, search, limit, domain);
			}, 1000);
		}
	};

	const takeDownValue = (res) => {
		let ip;
		res?.dnsDetails?.map((row) => {
			return Object.keys(row || {}).map((key) => {
				let record = row[key];
				if (record && record.length == 0) return false;
				if (key !== "dns_a") return false;
				record?.map((val) => {
					ip = val;
				});
			});
		});
		let originalWebsite = client.website;
		let domainName = res.host;
		ip = res.ip;
		setStolenLocation(originalWebsite);
		setContenSource(domainName);
		setInfringingIp(ip);
		setRowId(res._id);
		setUserComment("");
		setUploadedFile(null);
		setFilePreview(null);
		// Clear file input
		if (fileInputRef.current) {
			fileInputRef.current.value = "";
		}
		setTakeDownModal(true);
	};

	const exportToCSVNew = (fileName) => {
		const downloadExcel = Object.keys(modalBody).map((val) => {
			let value = modalBody[val];
			if (fileName == "Hosts Location") {
				return {
					HostsLocation: val?.replace(/['"]+/g, ""),
					IP: JSON.stringify(value.map((res) => res))
						?.replace(/[\[\]']+/g, "")
						?.replace(/['"]+/g, ""),
				};
			} else if (fileName == "Cloud / ISP Provider") {
				return {
					CloudProvider: val?.replace(/['"]+/g, ""),
					IP: JSON.stringify(value.map((res) => res))
						?.replace(/[\[\]']+/g, "")
						?.replace(/['"]+/g, ""),
				};
			} else if (fileName == "Network Services") {
				return {
					NetworkServices: val?.replace(/['"]+/g, ""),
					IP: JSON.stringify(value.map((res) => res))
						?.replace(/[\[\]']+/g, "")
						?.replace(/['"]+/g, ""),
				};
			}
		});

		const ws = XLSX.utils.json_to_sheet(downloadExcel);
		const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
		const data = new Blob([excelBuffer], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
		});
		FileSaver.saveAs(data, fileName + ".xlsx");
	};

	let clientName = "";

	if (JSON.parse(localStorage.getItem("OrgName"))) {
		if (sessionStorage.getItem("vendorId")) {
			clientName = sessionStorage.getItem("vendorName");
		} else {
			clientName = JSON.parse(localStorage.getItem("OrgName"));
		}
	}

	const downloadFile = async () => {
		try {
			const session = localStorage.getItem("session");
			axios.defaults.headers.common[
				"Authorization"
			] = `Bearer ${session}`;
			const response = await axios.get(
				`${API_URL}/brand-mentions/${id}/excel`,
				{
					responseType: "blob",
				}
			);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute(
				"download",
				`${clientName?.replace(/\s+/g, "-")}Brand Mention.xlsx`
			);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
		} catch (error) {
			// console.error removed
		}
	};

	let currentTableData = [];

	currentTableData = table;

	const [selectedIds, setSelectedIds] = useState([]);
	const [multiCheckTrue, setMultiCheckTrue] = useState(false);

	const addModal = () => {
		setModalTwo("Form Wizard modal two");
	};

	const multicheck = (data) => {
		const allIds = data?.map((item) => item?._id);
		if (selectedIds?.length > 0 || selectedIds?.length == 0) {
			setMultiCheckTrue(true);
			setSelectedIds(allIds);
		}
		if (multiCheckTrue == true) {
			setSelectedIds([]);
			setMultiCheckTrue(false);
		}
	};

	const singleClick = (id) => {
		setSelectedIds((prevSelectedIds) => {
			if (prevSelectedIds.includes(id)) {
				return prevSelectedIds.filter(
					(selectedId) => selectedId !== id
				);
			} else {
				return [...prevSelectedIds, id];
			}
		});
		if (selectedIds.length > 10) {
			setMultiCheckTrue(true);
		} else {
			setMultiCheckTrue(false);
		}
	};

	// Submit bulk takedown request
	const submitBulkTakeDown = async () => {
		if (bulkTakeDownComment.trim() === "") {
			toastr.error("Error", "Comment cannot be empty.");
			return false;
		}

		if (selectedIds.length === 0) {
			toastr.error("Error", "Please select at least one record.");
			return false;
		}

		try {
			// Build entries array from selected IDs
			const entries = selectedIds.map((recordId) => ({
				recordId: recordId,
				moduleName: "brand_mentions",
				userComment: bulkTakeDownComment,
			}));

			setBulkTakeDownModal(false);
			
			// Call bulk takedown API
			const response = await bulkTakeDown(id, entries, dispatch);
			
			// Refresh the listing after successful bulk takedown request
			if (response && !response.error) {
				brandMention(id, dispatch, page, category, search, limit, domain);
				setSelectedIds([]);
				setMultiCheckTrue(false);
			}
			
			// Reset form
			setBulkTakeDownComment("");
		} catch (error) {
			console.error("Error submitting bulk takedown request:", error);
		}
	};

	const snooze = (_id, event, name) => {
		if (event == "markAsRemidiated") {
			const data = {
				action: "markAsRemidiated",
				brandMentionIds: selectedIds == 0 ? _id : selectedIds,
				actionNote: "",
				for: "forever",
			};
			brandMentionAction(
				id,
				dispatch,
				page,
				category,
				search,
				data,
				limit,
				domain
			);
			setSelectedValue("pleaseSelect");
			setActionNote("");
			setSelectedIds([]);
		}
	};

	const Unsnoozed = (_id) => {
		const data = {
			action: "resetAction",
			brandMentionIds: selectedIds == 0 ? [_id] : selectedIds,
		};
		brandMentionAction(
			id,
			dispatch,
			page,
			category,
			search,
			data,
			limit,
			domain
		);
		setSelectedIds([]);
	};

	const submit = () => {
		const data = {
			action: action,
			brandMentionIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
			actionNote: actionNote,
			for: forValue,
		};
		brandMentionAction(
			id,
			dispatch,
			page,
			category,
			search,
			data,
			limit,
			domain
		);
		setModalTwo("");
		setSelectedValue("pleaseSelect");
		setActionNote("");
		setSelectedIds([]);
	};

	const reScan = () => {
		let data = {
			moduleName: ["brandMentions"],
		};
		rescanSingle(id, data);
	};

	const handleAddBrandMention = () => {
		if (!lookalike) {
			toastr.error("Error", "Lookalike domain is required.");
			return false;
		}

		const payload = {
			organisationId: id,
			host: lookalike,
			updatedAt: new Date().toISOString(),
		};

		brandMentionAdd(payload);

		// Reset form fields and close modal
		setLookalike("");
		setOriginal("");
		setFuzzer("typo");
		setAddBrandMentionModal(false);
	};

	const handleExternalUrlClick = (url) => {
		setRedirectUrl(url);
		setShowUrlWarningModal(true);
	};

	const handleRedirect = () => {
		window.open(redirectUrl, "_blank");
		setShowUrlWarningModal(false);
	};

	// Function to handle viewing ticket details
	const handleViewTicketDetails = (mention) => {
		setSelectedTicket(mention);
		setIsTicketDetailsModal(true);
	};

	return (
		<>
			<div className="container-fluid">
			<AccessPage></AccessPage>
			<Modal
				open={addIpModel}
				onClose={() => setAddIpModel(false)}
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
			>
				{modalBodyData}
			</Modal>
			<div className="block-header">
				<div className="row clearfix">
					<div className="col-md-4 col-sm-12">
						<h1 className="welcome-text">Brand Mentions </h1>
						<nav aria-label="breadcrumb" className="mt-1">
							<ol className="breadcrumb">
								<li className="breadcrumb-item">
									{vendorId ? (
										<>
											<Link
												to="/vendor"
												onClick={() => {
													sessionStorage.clear();
												}}
											>
												Vendor Assessment
											</Link>
										</>
									) : (
										<Link
											to="/"
											className="welcome-textSmall"
										>
											Home
										</Link>
									)}
								</li>
								{vendorName ? (
									<li
										className="breadcrumb-item active"
										aria-current="page"
										style={{ color: "white" }}
									>
										<Link
											to={`/dashboard/vendor/${vendorId}`}
										>
											{vendorName}
										</Link>
									</li>
								) : (
									""
								)}
								<li
									className="breadcrumb-item active"
									aria-current="page"
									style={{ color: "white" }}
								>
									Brand Mentions
								</li>
							</ol>
						</nav>
					</div>
					<div className="col-md-8 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
						<span>
							<a
								onClick={(e) => {
									e.preventDefault();
									setIsRecommendationModal(true);
								}}
								href="#"
								className="btn btn-sm btn-primary mr-1"
								style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
							>
								<i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
								Recommendation
							</a>
						</span>
						

						<span>
							{currentTableData?.brandMentions?.length ==
								0 ? null : (
								<>
									<a
										onClick={(e) => {
											e.preventDefault();
											downloadFile();
										}}
										href="/add-report"
										className="btn btn-sm btn-primary mr-1 download-report"
									>
										Download Details
									</a>
								</>
							)}
						</span>
						
					</div>
				</div>
			</div>

			{typeof scanCompleted !== "undefined" && !scanCompleted && (
				<div className="card border-success">
					<ScanMessage />
				</div>
			)}

			<div className="row clearfix">
				<div className="col-lg-12 col-md-12">
					<ul
						className="nav nav-tabs mb-2"
						id="myTabs"
						role="tablist"
					>
						<li className="nav-item">
							<a
								className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
									}`}
								onClick={() => {
									setCategory("all");
									setPage(1);
									setSearch("");
									setSelectedIds([]);
									setDomain("");
								}}
							>
								Current
							</a>
						</li>
						<li className="nav-item">
							<a
								className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
									}`}
								onClick={() => {
									setCategory("risk-accepted");
									setPage(1);
									setSearch("");
									setSelectedIds([]);
									setDomain("");
								}}
							>
								Risk Accepted
							</a>
						</li>
						<li className="nav-item">
							<a
								className={`nav-link nav-table-tab ${category === "false-positive"
									? "active"
									: ""
									}`}
								onClick={() => {
									setCategory("false-positive");
									setPage(1);
									setSearch("");
									setSelectedIds([]);
									setDomain("");
								}}
							>
								False Positive
							</a>
						</li>
						<li className="nav-item">
							<a
								className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
									}`}
								onClick={() => {
									setCategory("remidiated");
									setPage(1);
									setSearch("");
									setSelectedIds([]);
									setDomain("");
								}}
							>
								Remediated
							</a>
						</li>
					</ul>
					<div className="card card_tableBox">
						<div className="body">
							<div className="header">
								<div className="row clearfix">
									<div className="col-sm-3 mb-2">
										<div className="searchBoxInput p-0">
											<input
												class="form-control form-control-sm ml-0 my-1"
												type="text"
												placeholder="Search"
												aria-label="Search"
												value={search}
												onChange={(e) => {
													setSearch(e.target.value);
													setPage(1);
												}}
											/>
										</div>
									</div>
									<div className="col-sm-3 mb-2">
										<select
											className="custom-select custom-select-sm form-control form-control-sm"
											placeholder="Select Domain"
											value={domain}
											onChange={(e) => {
												setDomain(e.target.value);
												setPage(1);
											}}
										>
											<option value="">
												All Domains
											</option>
											{customerDomains?.domains?.map(
												(domainItem, index) => (
													<option
														key={index}
														value={domainItem}
													>
														{domainItem}
													</option>
												)
											)}
										</select>
									</div>
									<div className="col-sm-6 mb-2 d-flex align-items-center">
										{selectedIds.length > 1 &&
											userPermission &&
											category === "all" && (
												<Box sx={{ width: 160 }}>
													<FormControl fullWidth>
														<Select
															labelId="demo-simple-select-label"
															id="demo-simple-select"
															value={
																selectedValue
															}
															onChange={(
																event
															) => {
																setAction(
																	event.target
																		.value
																);
																snooze(
																	"",
																	event.target
																		.value
																);
															}}
														>
															<MenuItem value="pleaseSelect">
																Snooze Options
															</MenuItem>
															<MenuItem
																value="riskAccepted"
																onClick={() => {
																	addModal();
																}}
															>
																Risk Accepted
															</MenuItem>
															<MenuItem
																value="markAsFalsePositive"
																onClick={() => {
																	addModal();
																}}
															>
																False Positive
															</MenuItem>
															<MenuItem value="markAsRemidiated">
																Remediated
															</MenuItem>
														</Select>
													</FormControl>
												</Box>
											)}
							  	{selectedIds.length > 1 && userPermission && category === "all" && (
											<button
												className="btn btn-danger btn-sm ml-2"
												onClick={() => setBulkTakeDownModal(true)}
												title="Request takedown for selected brand mentions"
											>
												<i className="fa fa-arrow-down mr-1"></i>
												Bulk Takedown Request
											</button>
										)}
              			
										{selectedIds.length > 1 &&
											userPermission &&
											(category == "false-positive" ||
												category ==
												"risk-accepted") && (
												<button
													className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
													onClick={() =>
														Unsnoozed("")
													}
												>
													Unsnooze
												</button>
											)}
									</div>

								</div>

								<div className="table-responsive">
									<table className="table table-custom spacing5 mb-0" style={{ tableLayout: "auto", width: "100%" }}>
										<thead>
											<tr>
												{auth?.accessLevel !=
													"Threat Analyst" &&
													(category === "all" ||
														category ===
														"risk-accepted" ||
														category ===
														"false-positive") && (
														<th>
															<input
																type="checkbox"
																checked={
																	selectedIds ==
																		0
																		? false
																		: multiCheckTrue
																}
																onClick={() => {
																	multicheck(
																		currentTableData?.brandMentions
																	);
																}}
																className="checkUncheck"
															/>
														</th>
													)}
												<th style={{ 
													whiteSpace: "normal", 
													wordBreak: "break-word",
													maxWidth: "250px",
													minWidth: "200px"
												}}>URL</th>
												<th style={{ 
													whiteSpace: "normal",
													wordBreak: "break-word",
													maxWidth: "200px",
													minWidth: "150px"
												}}>
													Brand Impersonation Analysis
												</th>
												<th style={{ 
													whiteSpace: "normal",
													wordBreak: "break-word",
													maxWidth: "200px",
													minWidth: "150px"
												}}>
													Suspected Website Analysis
												</th>
												<th>Screen Shot</th>
												<th>Impersonation Score</th>
												<th>Last Updated on</th>
												<th>Take Down Status</th>
												{category !== "all" && (
													<th>Action Note</th>
												)}
												{auth?.accessLevel !=
													"Threat Analyst" &&
													userPermission &&
													(category === "all" ||
														category ===
														"risk-accepted" ||
														category ===
														"false-positive") && (
														<th
															style={{
																width: "80",
															}}
														>
															Action
														</th>
													)}
											</tr>
										</thead>
										<tbody>
											{currentTableData?.brandMentions?.map(
												(row) => {
													return (
														<tr>
															{auth?.accessLevel !=
																"Threat Analyst" &&
																(category ===
																	"all" ||
																	category ===
																	"risk-accepted" ||
																	category ===
																	"false-positive") && (
																	<td>
																		<input
																			onClick={() =>
																				singleClick(
																					row?._id
																				)
																			}
																			checked={selectedIds?.includes(
																				row?._id
																			)}
																			type="checkbox"
																			className="checkUncheck"
																		/>
																	</td>
																)}
															<td style={{ 
																whiteSpace: "normal",
																wordBreak: "break-all",
																overflowWrap: "break-word",
																maxWidth: "250px",
																minWidth: "200px",
																verticalAlign: "top",
																padding: "8px",
																lineHeight: "1.5"
															}}>
																{row?.subDomainName ? (
																	<a
																		href="#"
																		onClick={(
																			e
																		) => {
																			e.preventDefault();
																			handleExternalUrlClick(
																				row?.subDomainName?.startsWith(
																					"http://"
																				) ||
																					row?.subDomainName?.startsWith(
																						"https://"
																					)
																					? row?.subDomainName
																					: `http://${row?.subDomainName}`
																			);
																		}}
																		style={{ 
																			color: "#17a2b8",
																			textDecoration: "none",
																			wordBreak: "break-all",
																			overflowWrap: "break-word",
																			display: "inline-block",
																			maxWidth: "100%"
																		}}
																	>
																		{
																			row?.subDomainName
																		}
																	</a>
																) : "N/A"}
															</td>
															<td className="cursor">
																<Link
																	to="#"
																	onClick={() => {
																		setModalDetailsDataOne(
																			row?.brandImpersonationAnalysis
																		);
																		setModalDetailsOne(
																			true
																		);
																	}}
																>
																	Details
																</Link>
															</td>
															<td className="cursor">
																<Link
																	to="#"
																	onClick={() => {
																		setModalDetailsDataTwo(
																			row?.suspectedWebsiteAnalysis
																		);
																		setModalDetailsTwo(
																			true
																		);
																	}}
																>
																	Details
																</Link>
															</td>
															<td>
																{row
																	?.suspectedWebsiteAnalysis
																	?.full_page_screenshot ? (
																	<Fancybox
																		options={{
																			Carousel:
																			{
																				infinite: false,
																			},
																		}}
																	>
																		<a
																			data-fancybox="gallery"
																			href={
																				row
																					?.suspectedWebsiteAnalysis
																					?.full_page_screenshot
																			}
																		>
																			<img
																				src={
																					row
																						?.suspectedWebsiteAnalysis
																						?.full_page_screenshot
																				}
																				alt="Screen Shot"
																				style={{
																					width: "100px",
																					height: "100px",
																					cursor: "pointer",
																					objectFit:
																						"cover",
																				}}
																			// onError={(e) => {
																			//   e.target.onerror = null;
																			//   // e.target.src = "/path/to/fallback-image.png";
																			//   e.target.alt = "Image not available";
																			// }}
																			/>
																		</a>
																	</Fancybox>
																) : (
																	<span>
																		Image
																		not
																		available
																	</span>
																)}
															</td>
															<td>
																{row?.impersonationScore ||
																	"0"}
															</td>
															<td>
																{moment(
																	row?.updatedAt
																).format(
																	"DD-MM-YYYY"
																)}
															</td>
															<td>
																{row?.ticketExists ? (
																	<div>
																		<span
																			className={`badge badge-${row?.ticketStatus ===
																				"completed"
																				? "success"
																				: row?.ticketStatus ===
																					"inProgress"
																					? "warning"
																					: "info"
																				}`}
																		>
																			{row?.ticketStatus ===
																				"completed"
																				? "Completed"
																				: row?.ticketStatus ===
																					"inProgress"
																					? "In Progress"
																					: row?.ticketStatus ||
																					"Submitted"}
																		</span>
																		<div className="mt-1">
																			<button
																				className="btn btn-sm btn-outline-info"
																				onClick={() =>
																					handleViewTicketDetails(
																						row
																					)
																				}
																				title="View Ticket Details"
																			>
																				<i className="fa fa-ticket mr-1"></i>
																				Ticket
																				Details
																			</button>
																		</div>
																	</div>
																) : (
																	<Link
																		to="#"
																		className="takeDownBtn"
																		onClick={() =>
																			takeDownValue(
																				row
																			)
																		}
																	>
																		Request
																		Takedown{" "}
																		<i className="fa fa-arrow-down ml-2"></i>
																	</Link>
																)}
															</td>
															{category !==
																"all" && (
																	<td
																		style={{
																			whiteSpace:
																				"unset",
																		}}
																	>
																		{row?.actionNote
																			? row.actionNote
																			: "N/A"}
																	</td>
																)}
															{row?.remediationPending ==
																true ? (
																<td>
																	Retest in
																	progress
																</td>
															) : (
																<>
																	{auth?.accessLevel !=
																		"Threat Analyst" &&
																		userPermission &&
																		category ===
																		"all" && (
																			<td>
																				<Box
																					sx={{
																						width: 160,
																					}}
																				>
																					<FormControl
																						fullWidth
																					>
																						<Select
																							labelId="demo-simple-select-label"
																							id="demo-simple-select"
																							value={
																								selectedValue
																							}
																							onChange={(
																								event
																							) => {
																								setAction(
																									event
																										.target
																										.value
																								);
																								snooze(
																									row?._id
																								);
																							}}
																						>
																							<MenuItem value="pleaseSelect">
																								Snooze
																								Options
																							</MenuItem>
																							<MenuItem
																								value="riskAccepted"
																								onClick={() => {
																									addModal();
																									setLookalikeAppId(
																										[
																											row?._id,
																										]
																									);
																								}}
																							>
																								Risk
																								Accepted
																							</MenuItem>
																							<MenuItem
																								value="markAsFalsePositive"
																								onClick={() => {
																									addModal();
																									setLookalikeAppId(
																										[
																											row?._id,
																										]
																									);
																								}}
																							>
																								False
																								Positive
																							</MenuItem>
																							<MenuItem value="markAsRemidiated">
																								Remediated
																							</MenuItem>
																						</Select>
																					</FormControl>
																				</Box>
																			</td>
																		)}
																</>
															)}
															{auth?.accessLevel !=
																"Threat Analyst" &&
																userPermission &&
																(category ===
																	"risk-accepted" ||
																	category ===
																	"false-positive") && (
																	<td>
																		<button
																			className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
																			onClick={() =>
																				Unsnoozed(
																					row?._id
																				)
																			}
																		>
																			Unsnooze
																		</button>
																	</td>
																)}
														</tr>
													);
												}
											)}
										</tbody>
									</table>
								</div>
								<div className="d-flex justify-content-between align-content-center">
									<div className="dataTables_paginate">
										{totalItems > 0 && (
											<Pagination
												className="pagination-bar"
												currentPage={page}
												totalCount={totalItems}
												pageSize={limit}
												onPageChange={(page) =>
													setPage(page)
												}
											/>
										)}
									</div>
									{totalItems > 10 && (
										<select
											value={limit}
											onChange={(e) => {
												setLimit(e.target.value);
											}}
											className="form-control limitSelectBox"
										>
											<option value={10}>
												10 per page
											</option>
											<option value={25}>
												25 per page
											</option>
											<option value={50}>
												50 per page
											</option>
											<option value={100}>
												100 per page
											</option>
										</select>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* <div className="col-lg-4 col-md-12">
          <div className="card user_statistics">
            <div className="body" style={{ height: "400px" }}>
              <span>Previous scan details</span>
              {scanDetails && (
                <BasicLineColumn
                  dates={scanDetails?.dates}
                  // openPortArray={openPortArray}
                  ipArray={ipArray}
                  color={["#008ffb", "#00e396"]}
                  yAxis="IP Discovered"
                />
              )}
            </div>
          </div>
        </div> */}
			</div>

			<div
				className={`modal fade Form-Wizard-modal ${isModal ? "d-block show" : ""
					}`}
			>
				<div className="modal-dialog modal-lg assetsDiscoveryModal">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="exampleModalLabel">
								{modalHeading}
							</h5>
							<button
								type="button"
								data-dismiss="modal"
								aria-label="Close"
								onClick={() => setModal(false)}
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body pricing_page">
							<div id="wizard_horizontal">
								<section>
									<div className="row">
										<div className="col-sm-12">
											<a
												onClick={(e) => {
													e.preventDefault();
													exportToCSVNew(
														modalHeading
													);
												}}
												href="/add-report"
												style={{ float: "right" }}
												className="btn btn-primary mr-1"
											>
												<i className="fa fa-file-excel-o"></i>
											</a>
										</div>
									</div>
									<div className="card">
										{/* <div className="body"> */}
										<div className="table-responsive">
											<table className="table table-hover table-custom spacing5">
												<thead>
													<tr>
														{Object.keys(
															modalBody
														).map((val) => {
															return (
																<th
																	style={{
																		width: "200",
																	}}
																>
																	{val?.replace(
																		/['"]+/g,
																		""
																	)}
																</th>
															);
														})}
													</tr>
												</thead>
												<tbody>
													<tr>
														{Object.keys(
															modalBody
														).map((val) => {
															let value =
																modalBody[val];
															return (
																<td
																	style={{
																		verticalAlign:
																			"top",
																	}}
																>
																	{value?.map(
																		(
																			row
																		) => {
																			return (
																				<>
																					<span>
																						{
																							row
																						}
																					</span>
																					<br />
																				</>
																			);
																		}
																	)}
																</td>
															);
														})}
													</tr>
												</tbody>
											</table>
										</div>
										{/* </div> */}
									</div>
								</section>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				className={`modal fade Form-Wizard-modal ${certModal ? "d-block show" : ""
					}`}
			>
				<div className="modal-dialog modal-lg assetsDiscoveryModal">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="exampleModalLabel">
								Certificate
							</h5>
							<button
								type="button"
								data-dismiss="modal"
								aria-label="Close"
								onClick={() => setCertModal(false)}
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body pricing_page">
							<div id="wizard_horizontal">
								<section>
									<div
										className="card"
										dangerouslySetInnerHTML={{
											__html: certModalBody?.replace(
												/\n/g,
												"<br />"
											),
										}}
									>
										{/* {certModalBody}
                    dangerouslySetInnerHTML={{__html: alert.alertContent}} */}
									</div>
								</section>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				className={`modal fade  ${ipRemoveModal ? "d-block show" : ""}`}
				id="exampleModal"
				onClick={() => setIpRemoveModal(false)}
			>
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="exampleModalLabel">
								Delete
							</h5>
							<button
								type="button"
								className="close"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body">
							<p>Are you sure you want to delete?</p>
						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-round btn-default"
								data-dismiss="modal"
								onClick={() => setIpRemoveModal(false)}
							>
								Cancel
							</button>
							<button
								type="button"
								className="btn btn-round btn-primary"
								onClick={() => {
									deleteIp(ipId, id, true, dispatch);
									setIpRemoveModal(false);
								}}
							>
								Confirm
							</button>
						</div>
					</div>
				</div>
			</div>

			<div
				className={`modal fade Form-Wizard-modal ${modalDetailsOne ? "d-block show" : ""
					}`}
			>
				<div className="modal-dialog modal-lg" id="clientModal">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="exampleModalLabel">
								Brand Impersonation Analysis
							</h5>
							<button
								type="button"
								data-dismiss="modal"
								aria-label="Close"
								onClick={() => setModalDetailsOne(false)}
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body">
							<div className="row clearfix">
								<div className="col-lg-12 col-md-12 col-sm-12">
									<table className="table table-responsive">
										<thead>
											<tr>
												<th>Conclusion</th>
												<th>Mention Type</th>
												<th>Mentions</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td className="text-wrap">
													{modalDetailsDataOne?.conclusion ||
														"N/A"}
												</td>
												<td>
													{modalDetailsDataOne?.mention_type ||
														"N/A"}
												</td>
												<td className="text-wrap">
													{modalDetailsDataOne?.mentions &&
														Array.isArray(
															modalDetailsDataOne.mentions
														)
														? modalDetailsDataOne.mentions.map(
															(r, index) => (
																<span
																	key={
																		index
																	}
																>
																	{r ||
																		"N/A"}
																</span>
															)
														)
														: "N/A"}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				className={`modal fade Form-Wizard-modal ${modalDetailsTwo ? "d-block show" : ""
					}`}
			>
				<div className="modal-dialog modal-lg" id="clientModal">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="exampleModalLabel">
								Suspected Website Analysis
							</h5>
							<button
								type="button"
								data-dismiss="modal"
								aria-label="Close"
								onClick={() => setModalDetailsTwo(false)}
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body">
							<div className="row clearfix">
								<div className="col-lg-12 col-md-12 col-sm-12">
									<table className="table table-responsive">
										<thead>
											<tr>
												<th>Url</th>
												<th>Full Page Screenshot</th>
												<th>Description</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>
													<a
														href={
															modalDetailsDataTwo?.url
														}
														target="_blank"
													>
														{modalDetailsDataTwo?.url ||
															"N/A"}
													</a>
												</td>
												<td>
													{modalDetailsDataTwo?.full_page_screenshot ? (
														<Fancybox
															options={{
																Carousel: {
																	infinite: false,
																},
															}}
														>
															<a
																data-fancybox="gallery"
																href={
																	modalDetailsDataTwo?.full_page_screenshot
																}
															>
																<img
																	alt=""
																	src={
																		modalDetailsDataTwo?.full_page_screenshot
																	}
																	style={{
																		width: "100px",
																		height: "100px",
																		objectFit:
																			"cover",
																	}}
																/>
															</a>
														</Fancybox>
													) : (
														"N/A"
													)}
												</td>
												<td className="text-wrap">
													{modalDetailsDataTwo?.description ||
														"N/A"}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className={`modal fade Form-Wizard-modal ${isModalTwo === "Form Wizard modal two" ? "d-block show" : ""
					}`}
			>
				<div className="modal-dialog modal-lg" id="clientModal">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="exampleModalLabel">
								{action == "markAsFalsePositive"
									? "Mark As False Positive"
									: "Risk Accepted"}
							</h5>
							<button
								type="button"
								data-dismiss="modal"
								aria-label="Close"
								onClick={() => {
									setModalTwo("");
									setActionNote("");
								}}
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body pricing_page modal_mob">
							<div className="col-xl-12 col-lg-12 col-md-12">
								<div className="card">
									<div className="row clearfix">
										<div className="col-md-12">
											<label className="col-lg-6 col-md-12">
												Snooze for
											</label>
											<div className="form-group ol-lg-12 col-md-12">
												<select
													className="custom-select custom-select-sm form-control form-control-sm"
													onChange={(e) =>
														setForValue(
															e.target.value
														)
													}
												>
													<option value="forever">
														Forever
													</option>
													<option value="3 months">
														3 Months
													</option>
													<option value="6 months">
														6 Months
													</option>
													<option value="12 months">
														12 Months
													</option>
												</select>
											</div>
										</div>
										<div className="col-md-12">
											<label className="col-lg-12 col-md-12">
												Detail
											</label>
											<div className="form-group col-lg-12 col-md-12">
												<textarea
													onChange={(e) =>
														setActionNote(
															e.target.value
														)
													}
													value={actionNote}
													className="form-control"
													rows="3"
												></textarea>
											</div>
										</div>
									</div>
									<div className="row">
										<div
											className="col-lg-12 col-md-12"
											style={{ marginRight: "28px" }}
										>
											<button
												type="button"
												style={{
													color: "black",
													fontWeight: "bold",
												}}
												onClick={submit}
												className="btn btn-round btn-primary mr-1 pull-right"
											>
												Submit
											</button>
											&nbsp;&nbsp;
											<button
												type="button"
												onClick={() => {
													setModalTwo("");
													setActionNote("");
												}}
												className="btn btn-round btn-default pull-right"
												style={{ marginRight: "10px" }}
											>
												Cancel
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				className={`modal fade Form-Wizard-modal ${isAddBrandMentionModal ? "d-block show" : ""
					}`}
			>
				<div
					className="modal-dialog modal-lg"
					id="addBrandMentionModal"
				>
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">Add Brand Mention</h5>
							<button
								type="button"
								className="close"
								onClick={() => setAddBrandMentionModal(false)}
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body">
							<div className="card mb-0">
								<div className="card-body">
									<div className="row">
										<div className="col-md-12">
											<div className="form-group">
												<label>
													Domain Host{" "}
													<span className="text-danger">
														*
													</span>
												</label>
												<input
													type="text"
													className="form-control"
													value={lookalike}
													onChange={(e) =>
														setLookalike(
															e.target.value
														)
													}
													placeholder="Enter domain host (e.g., example.com)"
													required
												/>
											</div>
										</div>
									</div>

									<div className="row mt-3">
										<div className="col-md-12 text-right">
											<button
												className="mr-2 btn btn-round btn-default"
												onClick={() =>
													setAddBrandMentionModal(
														false
													)
												}
											>
												Cancel
											</button>
											<button
												className="btn btn-primary"
												onClick={handleAddBrandMention}
											>
												Add Brand Mention
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Add URL Warning Modal */}
			<div
				className={`modal fade Form-Wizard-modal ${showUrlWarningModal ? "d-block show" : ""
					}`}
			>
				<div className="modal-dialog" id="urlWarningModal">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">
								External Link Warning
							</h5>
							<button
								type="button"
								className="close"
								onClick={() => setShowUrlWarningModal(false)}
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body">
							<div className="alert alert-warning mb-3">
								<i className="fa fa-exclamation-triangle mr-2"></i>
								You are about to leave this site and visit an
								external URL. This link may lead to a
								third-party website. Please proceed with
								caution.
							</div>
							<p className="mb-0">
								URL: <strong>{redirectUrl}</strong>
							</p>
						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-default"
								onClick={() => setShowUrlWarningModal(false)}
							>
								Cancel
							</button>
							<button
								type="button"
								className="btn btn-primary"
								onClick={handleRedirect}
							>
								Proceed Anyway
							</button>
						</div>
					</div>
				</div>
			</div>

			{/* Ticket Details Modal */}
			<div
				className={`modal fade Form-Wizard-modal ${isTicketDetailsModal ? "d-block show" : ""
					}`}
			>
				<div className="modal-dialog modal-md" id="ticketDetailsModal">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">Ticket Details</h5>
							<button
								type="button"
								className="close"
								onClick={() => setIsTicketDetailsModal(false)}
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body">
							{selectedTicket && (
								<div className="row clearfix">
									<div className="col-12">
										<div className="card mb-3">
											<div className="card-header">
												<h6 className="mb-0">
													Ticket Information
												</h6>
											</div>
											<div className="card-body">
												<div className="row">
													<div className="col-md-6">
														<p>
															<strong>
																Ticket ID:
															</strong>
														</p>
														<p className="text-muted font-monospace">
															{selectedTicket._id}
														</p>
													</div>
													<div className="col-md-6">
														<p>
															<strong>
																Status:
															</strong>
														</p>
														<span
															className={`badge badge-${selectedTicket?.ticketStatus ===
																"completed"
																? "success"
																: selectedTicket?.ticketStatus ===
																	"inProgress"
																	? "warning"
																	: "info"
																}`}
														>
															{selectedTicket?.ticketStatus ===
																"completed"
																? "Completed"
																: selectedTicket?.ticketStatus ===
																	"inProgress"
																	? "In Progress"
																	: selectedTicket?.ticketStatus ||
																	"Submitted"}
														</span>
													</div>
												</div>
												<div className="row mt-2">
													<div className="col-md-6">
														<p>
															<strong>
																Created:
															</strong>
														</p>
														<p>
															{new Date(
																selectedTicket.createdAt
															).toLocaleDateString()}
														</p>
													</div>
													{selectedTicket?.updatedAt &&
														selectedTicket.updatedAt !==
														selectedTicket.createdAt && (
															<div className="col-md-6">
																<p>
																	<strong>
																		Last
																		Updated:
																	</strong>
																</p>
																<p>
																	{new Date(
																		selectedTicket.updatedAt
																	).toLocaleDateString()}
																</p>
															</div>
														)}
												</div>
											</div>
										</div>

										<div className="card">
											<div className="card-header">
												<h6 className="mb-0">
													Request Details
												</h6>
											</div>
											<div className="card-body">
												<div className="row">
													<div className="col-md-6">
														<h6>User Comment:</h6>
														{selectedTicket?.userComment ? (
															<div className="alert alert-info">
																{
																	selectedTicket.userComment
																}
															</div>
														) : (
															<div className="alert alert-light">
																No comment
																provided
															</div>
														)}
													</div>
													<div className="col-md-6">
														<h6>Admin Comment:</h6>
														{selectedTicket?.actionNote ? (
															<div className="alert alert-warning">
																{
																	selectedTicket.actionNote
																}
															</div>
														) : (
															<div className="alert alert-light">
																No admin comment
																yet
															</div>
														)}
													</div>
												</div>
												{selectedTicket?.requestStatus && (
													<div className="mt-3">
														<h6>Status Details:</h6>
														<div className="alert alert-secondary">
															{
																selectedTicket.requestStatus
															}
														</div>
													</div>
												)}
											</div>
										</div>
									</div>
								</div>
							)}
						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-secondary"
								onClick={() => setIsTicketDetailsModal(false)}
							>
								Close
							</button>
						</div>
					</div>
				</div>
			</div>

			{/* Recommendation Modal */}
			{isRecommendationModal && (
				<div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
					<div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
						<button
							className="recommendation-modal-close"
							onClick={() => setIsRecommendationModal(false)}
						>
							&times;
						</button>

						<div className="recommendation-modal-content">
							<div className="recommendation-tabs">
								<button
									className={`recommendation-tab ${activeRecommendationTab === "guide" ? "active" : ""
										}`}
									onClick={() => setActiveRecommendationTab("guide")}
								>
									Guidance
								</button>
								<button
									className={`recommendation-tab ${activeRecommendationTab === "checklist" ? "active" : ""
										}`}
									onClick={() => setActiveRecommendationTab("checklist")}
								>
									Action Checklist
								</button>
							</div>

							{/* GUIDANCE TAB */}
							<div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
								<div className="guide-intro">
									BrandSek monitors unauthorized usage of brand names, trademarks, logos,
									and keywords across websites, social platforms, forums, marketplaces,
									and underground communities. Such abuse is often leveraged to build
									credibility for phishing, fraud, and impersonation campaigns.
								</div>

								<details className="checklist-details" open>
									<summary className="checklist-summary">
										<div className="summary-left">
											<h3>What Are Brand Mentions Risks</h3>
										</div>
									</summary>
									<div className="checklist-card-content">
										<p>
											Brand mentions risk arises when third-party sites or profiles reference
											the organization without authorization. While some mentions may be
											benign, malicious actors frequently misuse brand identity to deceive
											users and conduct scams.
										</p>
									</div>
								</details>

								<details className="checklist-details">
									<summary className="checklist-summary">
										<div className="summary-left">
											<h3>Sources Covered</h3>
										</div>
									</summary>
									<div className="checklist-card-content">
										<ul className="checklist-items">
											<li>Websites, blogs, landing pages, and microsites</li>
											<li>Social media posts, comments, bios, and advertisements</li>
											<li>Forums, Q&amp;A platforms, and developer communities</li>
											<li>Dark web forums and marketplaces</li>
											<li>Telegram channels, Discord servers, and closed groups</li>
											<li>SEO-poisoned pages abusing brand keywords</li>
										</ul>
									</div>
								</details>

								<details className="checklist-details">
									<summary className="checklist-summary">
										<div className="summary-left">
											<h3>Common Abuse Scenarios</h3>
										</div>
									</summary>
									<div className="checklist-card-content">
										<ul className="checklist-items">
											<li>Unauthorized logo or trademark usage</li>
											<li>Fake customer support or grievance portals</li>
											<li>Brand keyword abuse for phishing SEO</li>
											<li>Fraudulent promotions, refunds, or investment schemes</li>
											<li>Misinformation and reputation attacks</li>
										</ul>
									</div>
								</details>

								<details className="checklist-details">
									<summary className="checklist-summary">
										<div className="summary-left">
											<h3>Business & Compliance Impact</h3>
										</div>
									</summary>
									<div className="checklist-card-content">
										<p>
											Uncontrolled brand abuse may lead to customer fraud, reputational
											damage, and regulatory scrutiny. Continuous monitoring supports
											ISO 27001 brand protection controls, CERT-In advisories, and
											legal enforcement actions.
										</p>
									</div>
								</details>
							</div>

							{/* CHECKLIST TAB */}
							<div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
								<details className="checklist-details" open>
									<summary className="checklist-summary">
										<div className="summary-left">
											<h3>Validation & Classification</h3>
											<span className="severity-badge high">High</span>
										</div>
									</summary>
									<div className="checklist-card-content">
										<ul className="checklist-items">
											<li>Confirm unauthorized brand or logo usage</li>
											<li>Validate similarity to official branding</li>
											<li>Identify impersonation or deceptive intent</li>
										</ul>
										<div className="compliance-tag">ISO 27001 A.5.7 · Threat Intelligence</div>
									</div>
								</details>

								<details className="checklist-details">
									<summary className="checklist-summary">
										<div className="summary-left">
											<h3>Threat & Fraud Assessment</h3>
											<span className="severity-badge high">High</span>
										</div>
									</summary>
									<div className="checklist-card-content">
										<ul className="checklist-items">
											<li>Check for phishing links or fake forms</li>
											<li>Identify payment diversion or scam patterns</li>
											<li>Correlate with customer or SOC alerts</li>
										</ul>
										<div className="compliance-tag">ISO 27001 A.8.16 · Fraud Prevention</div>
									</div>
								</details>

								<details className="checklist-details">
									<summary className="checklist-summary">
										<div className="summary-left">
											<h3>Takedown & Mitigation</h3>
											<span className="severity-badge medium">Medium</span>
										</div>
									</summary>
									<div className="checklist-card-content">
										<ul className="checklist-items">
											<li>Initiate takedown with platform or host</li>
											<li>Notify legal and brand teams</li>
											<li>Block URLs at email and web gateways</li>
										</ul>
										<div className="compliance-tag">CERT-In · Platform Abuse Policies</div>
									</div>
								</details>

								<details className="checklist-details">
									<summary className="checklist-summary">
										<div className="summary-left">
											<h3>Continuous Monitoring & Closure</h3>
											<span className="severity-badge low">Low</span>
										</div>
									</summary>
									<div className="checklist-card-content">
										<ul className="checklist-items">
											<li>Monitor for reappearance or mirrors</li>
											<li>Close issue once takedown confirmed</li>
											<li>Maintain evidence for audit reference</li>
										</ul>
										<div className="compliance-tag">ISO 27001 A.5.25 · Governance</div>
									</div>
								</details>
							</div>
						</div>
					</div>
				</div>
			)}

			{/* Take Down Request Modal */}
			<div
				className={`modal fade Form-Wizard-modal ${isTakeDownModal ? "d-block show" : ""
					}`}
			>
				<div className="modal-dialog modal-lg" id="takeDownModal">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">
								Submit Take Down Request
							</h5>
							<button
								type="button"
								className="close"
								onClick={() => {
									setTakeDownModal(false);
									setUserComment("");
									setUploadedFile(null);
									setFilePreview(null);
								}}
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body">
							<div className="card mb-0">
								<div className="card-body">
									<div className="row">
										<div className="col-md-12">
											<div className="form-group">
												<label>
													<strong>Comment</strong>{" "}
													<span className="text-danger">
														*
													</span>
												</label>
												<textarea
													className="form-control"
													rows="4"
													value={userComment}
													onChange={(e) =>
														setUserComment(
															e.target.value
														)
													}
													placeholder="Please provide details about the takedown request..."
													required
												/>
											</div>
										</div>
									</div>

									<div className="row mt-3">
										<div className="col-md-12">
											<div className="form-group">
												<label>
													<strong>
														Upload Supporting
														File/Screenshot
													</strong>{" "}
													(Optional)
												</label>
												<input
													ref={fileInputRef}
													type="file"
													className="form-control"
													accept="image/*,.pdf,.doc,.docx"
													onChange={handleFileChange}
												/>
												<small className="form-text text-muted">
													Supported formats: Images,
													PDF, DOC, DOCX (Max 10MB)
												</small>
											</div>
										</div>
									</div>

									{filePreview && (
										<div className="row mt-2">
											<div className="col-md-12">
												<div className="card">
													<div className="card-header d-flex justify-content-between align-items-center">
														<span>
															File Preview
														</span>
														<button
															type="button"
															className="btn btn-sm btn-danger"
															onClick={() => {
																setUploadedFile(
																	null
																);
																setFilePreview(
																	null
																);
															}}
														>
															<i className="fa fa-times"></i>{" "}
															Remove
														</button>
													</div>
													<div className="card-body text-center">
														<img
															src={filePreview}
															alt="Preview"
															style={{
																maxWidth:
																	"100%",
																maxHeight:
																	"300px",
																objectFit:
																	"contain",
															}}
														/>
													</div>
												</div>
											</div>
										</div>
									)}

									{uploadedFile && !filePreview && (
										<div className="row mt-2">
											<div className="col-md-12">
												<div className="alert alert-info d-flex justify-content-between align-items-center">
													<span>
														<i className="fa fa-file mr-2"></i>
														{uploadedFile.name} (
														{(
															uploadedFile.size /
															1024
														).toFixed(2)}{" "}
														KB)
													</span>
													<button
														type="button"
														className="btn btn-sm btn-danger"
														onClick={() => {
															setUploadedFile(
																null
															);
															setFilePreview(
																null
															);
															// Clear file input
															if (
																fileInputRef.current
															) {
																fileInputRef.current.value =
																	"";
															}
														}}
													>
														<i className="fa fa-times"></i>{" "}
														Remove
													</button>
												</div>
											</div>
										</div>
									)}

									<div className="row mt-4">
										<div className="col-md-12 text-right">
											<button
												type="button"
												className="btn btn-default mr-2"
												onClick={() => {
													setTakeDownModal(false);
													setUserComment("");
													setUploadedFile(null);
													setFilePreview(null);
													// Clear file input
													if (fileInputRef.current) {
														fileInputRef.current.value =
															"";
													}
												}}
											>
												Cancel
											</button>
											<button
												type="button"
												className="btn btn-primary"
												onClick={submitTakeDownValue}
												disabled={!userComment.trim()}
											>
												<i className="fa fa-paper-plane mr-2"></i>
												Submit Request
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
	</div>
		<div className={`modal fade Form-Wizard-modal ${isBulkTakeDownModal ? "d-block show" : ""}`}>
			<div className="modal-dialog modal-lg" id="bulkTakedownModal">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="bulkTakedownModalLabel">
							Bulk Takedown Request 
						</h5>
						<button
							type="button"
							data-dismiss="modal"
							aria-label="Close"
							onClick={() => setBulkTakeDownModal(false)}
						>
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div className="modal-body">
						<div className="row clearfix">
							<div className="col-lg-12 col-md-12 col-sm-12">
								<div className="card card_ck">
									<div className="body">
										<div className="col-md-12">
											<label className="col-lg-12 col-md-12">Comment <span className="text-danger">*</span></label>
											<div className="form-group col-lg-12 col-md-12">
												<textarea
													onChange={(e) => setBulkTakeDownComment(e.target.value)}
													value={bulkTakeDownComment}
													className="form-control"
													rows="3"
													placeholder="Enter comment for all selected items..."
													required
												></textarea>
											</div>
										</div>
										<div className="col-lg-12 col-md-12 takeDownButtonBox">
											<button
												className="btn btn-default btn-sm mr-1 pull-right"
												style={{ marginTop: "10px" }}
												onClick={() => {
													setBulkTakeDownModal(false);
													setBulkTakeDownComment("");
												}}
											>
												Cancel
											</button>
											<button
												className="btn btn-primary btn-sm mr-1 pull-right"
												style={{ marginTop: "10px" }}
												onClick={() => submitBulkTakeDown()}
											>
												Submit Bulk Takedown
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		</>
	);
};
export default AssetDiscovery;
